import DomainField from './domain_field'
import React from 'react'

const DomainFieldContainer = React.forwardRef((props, ref) => {

  const componentRef = React.useRef()

  React.useImperativeHandle(ref, () => ({
    clear: () => componentRef.current._handleClear(),
    focus: () => componentRef.current._handleFocus()
  }))

  return <DomainField ref={ componentRef } {...props} />

})

export default DomainFieldContainer
